import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[var(--ink)] text-[var(--bg)] mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="eyebrow text-[var(--bg)]/60 mb-4">Riga · Latvia</div>
            <h2 className="font-display text-5xl sm:text-7xl leading-none">
              Small tours.<br/>
              <span className="text-[var(--clay)]">Big stories.</span>
            </h2>
            <p className="mt-8 max-w-md text-[var(--bg)]/70 leading-relaxed">
              Riga Party Weekend runs a tight selection of experiences in and around Riga — for groups, mates and couples flying in for a weekend or longer.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-[var(--bg)]/60 mb-5">Explore</div>
            <ul className="space-y-3">
              <li><Link to="/tours" className="hover:text-[var(--clay)] transition-colors" data-testid="footer-link-tours">All tours</Link></li>
              <li><Link to="/about" className="hover:text-[var(--clay)] transition-colors" data-testid="footer-link-about">About us</Link></li>
              <li><Link to="/contact" className="hover:text-[var(--clay)] transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-[var(--bg)]/60 mb-5">Get in touch</div>
            <ul className="space-y-3 text-[var(--bg)]/85">
              <li className="flex items-center gap-2"><MapPin size={16} /> Balasta dambis 11, Riga</li>
              <li className="flex items-center gap-2"><Mail size={16} /> rigapartyweekend@rigapartyweekend.eu</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-[var(--bg)]/50 text-sm">
          <span>© {new Date().getFullYear()} Riga Party Weekend. All rights reserved.</span>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-[var(--clay)] transition-colors" data-testid="footer-link-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-[var(--clay)] transition-colors" data-testid="footer-link-terms">Terms</Link>
            <span>Made in Riga.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
